<template>
    <div class="footer">
        <div class="footer-content">
            <div class="footer-up">
                <div class="col1">
                    <ul>
                        <router-link tag="li" class="title" to="/project">{{ $t('footer.col1.i1') }}</router-link>
                        <!-- <router-link tag="li" <li class="title">  </li> -->
                        <router-link tag="li" to="/project">{{ $t('footer.col1.i2') }}</router-link>
                        <router-link tag="li" to="/data"> {{ $t('footer.col1.i3') }} </router-link>
                        <router-link tag="li" to="/welmshome"> {{ $t('footer.col1.i4') }} </router-link>
                        <a href="//global.wdyedu.com/" target="_blank"> {{ $t('footer.col1.i5') }} </a>
                        <router-link tag="li" to="/classrooms"> {{ $t('footer.col1.i6') }} </router-link>
                        <router-link tag="li" to="/look"> {{ $t('footer.col1.i8') }} </router-link>
                        <router-link tag="li" to="/solution"> {{ $t('footer.col1.i7') }} </router-link>
                        
                    </ul>
                </div>
                <div class="col2">
                    <ul>
                        <router-link  class="title" tag="li" to="/news"> {{ $t('footer.col2.i1') }} </router-link>
                        <router-link class="title" tag="li" to="/aboutus"> {{ $t('footer.col2.i2') }} </router-link>
                        <router-link tag="li" to="/aboutus?tabNum=0"> {{ $t('footer.col2.i3') }} </router-link>
                        <router-link tag="li" to="/aboutus?tabNum=1"> {{ $t('footer.col2.i4') }} </router-link>
                        <router-link tag="li" to="/aboutus?tabNum=2"> {{ $t('footer.col2.i5') }} </router-link>
                    </ul>
                </div>
                <div class="col3">
                    <div class="info"> {{ $t('footer.col3.i1') }} </div>
                    <div class="item">
                        <div class="item-col">
                            <a href="https://www.demos.fr/" target="_blank">
                                <img class="default" src="../assets/footer/footer_logo1.png" alt="">
                                <img class="mhover" src="../assets/footer/footer_logo1_hover.png" alt="">
                            </a>
                        </div>
                        <div class="item-col">
                            <a href="https://www.mindonsite.com/en/" target="_blank">
                                <img class="default" src="../assets/footer/footer_logo2.png" alt="">
                                <img class="mhover" src="../assets/footer/footer_logo2_hover.png" alt="">
                            </a>
                        </div>
                        <div class="item-col">
                            <a href="https://international.brest-bs.com/" target="_blank">
                            <img class="default" src="../assets/footer/footer_logo3.png" alt="">
                            <img class="mhover" src="../assets/footer/footer_logo3_hover.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-col">
                            <a href="https://www.hemsleyfraser.com/" target="_blank">
                            <img class="default" src="../assets/footer/footer_logo4.png" alt="">
                            <img class="mhover" src="../assets/footer/footer_logo4_hover.png" alt="">
                            </a>
                        </div>
                        <div class="item-col">
                            <a href="//www.simultrain.swiss/" target="_blank">
                            <img class="default" src="../assets/footer/footer_logo5.png" alt="">
                            <img class="mhover" src="../assets/footer/footer_logo5_hover.png" alt="">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col4">
                    <!-- <span>EN</span> | <a href="http://cn.wdecloud.com">中文</a> -->
                </div>
            </div>
            <div class="footer-center">
                <ul>
                    <router-link tag="li" to="/covid" style="cursor: pointer">{{ $t('footer.covid') }}</router-link>
                    <li>
                        <a href="https://www.facebook.com/Weidong-Cloud-Education-Group-105335877922654" target="_blank">
                            <img src="../assets/footer/footer_share1.png" alt="">
                            <img class="mover" src="../assets/footer/footer_share1_hover.png" alt="">
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/weidong-cloud-education-group" target="_blank">
                            <img src="../assets/footer/footer_share2.png" alt="">
                            <img class="mover" src="../assets/footer/footer_share2_hover.png" alt="">
                        </a>
                    </li>
                    <li>
                        <a href="https://twitter.com/WeidongGroup" target="_blank">
                            <img src="../assets/footer/footer_share3.png" alt="">
                            <img class="mover" src="../assets/footer/footer_share3_hover.png" alt="">
                        </a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/channel/UCVCAEYCuDseYaOXG-YPS2PQ/videos" target="_blank">
                        <img src="../assets/footer/footer_share4.png" alt="">
                        <img class="mover" src="../assets/footer/footer_share4_hover.png" alt="">
                        </a>
                    </li>
                </ul>
            </div>
            <div class="footer-down">
                <div class="line-1">
                    <img src="../assets/icon/logo_show-new@2x.png" alt=""><span style="margin-left: 0px">|</span> <span>{{ $t('footer.right') }}&nbsp;&nbsp;<router-link to="/privacy">{{ $t('footer.privacy') }}</router-link></span>
                </div>
                
                <div>
                    <a target="_blank" href="https://beian.miit.gov.cn/">{{ $t('footer.center') }}</a>
                </div>
                <!-- <img src="../assets/icon/logo_show1.png" alt=""> | <span>{{ $t('footer.right') }}<router-link to="/privacy">{{ $t('footer.privacy') }}</router-link></span> -->
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        created() {
            const checkCookie = localStorage.getItem('checkCookie');
            if (checkCookie === '1') {
                this.alertCookie = false;
            } else {
                this.alertCookie = true;
            }
        },
        data() {
            return {
                alertCookie: false,
            };
        },
        methods: {
            goPrivary() {
                localStorage.setItem('checkCookie', '1');
                this.$router.push({
                    path: '/privacy',
                })
                this.alertCookie = false;
            }
        }
    }
</script>

<style lang="less">
.footer {
    box-sizing: border-box;
    height: 460px;
    background: #131313;
    padding-top: 50px;
    color: #ffffff;
    .footer-content {
        width: 1200px;
        margin: 0 auto;
        .footer-up {
            display: flex;
            .col1 {
                font-size: 14px;
                font-family: HelveticaNeue,  Arial, sans-serif;
                font-weight: 400;
                color: #666;
                width: 220px;
                .title {
                    color: #ffffff;
                    font-size: 18px;
                    font-family: HelveticaNeue,  Arial, sans-serif;
                    font-weight: bold;
                    margin-bottom: 13px;
                    cursor: pointer;
                }
                li~li {
                    cursor: pointer;
                    margin-top: 8px;
                }
                a {
                    display: inline-block;
                    cursor: pointer;
                    margin-top: 8px;
                    text-decoration: none;
                    color: #666;
                }
                li:hover {
                    color: #fff;
                }
            }

            .col2 {
                margin-left: 35px;
                font-size: 14px;
                font-family: HelveticaNeue, Arial, sans-serif;
                font-weight: 400;
                color: #666;
                width: 200px;
                .title {
                    color: #ffffff;
                    font-size: 18px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    font-weight: bold;
                    margin-bottom: 21px;
                    cursor: pointer;
                }
                .title~.title {
                    margin-bottom: 12px;
                }
                li~li {
                    cursor: pointer;
                    margin-top: 10px;
                }
                li:hover {
                    color: #fff;
                }
            }

            .col3 {
                margin-left: 80px;
                .info {
                    font-size: 14px;
                    line-height: 1.5;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    width: 500px;
                    margin-bottom: 33px;
                }
                .item {
                    display: flex;
                    margin-bottom: 7px;
                    width: 376px;
                    height: 50px;
                    .item-col {
                        flex: 1;
                        font-size: 0;
                        &:hover {
                            cursor: pointer;
                            .default {
                                display: none;
                            }
                            .mhover {
                                display: block;
                            }
                        }
                        img {
                            width: 100%;
                        }
                    }

                    .mhover {
                        display: none;
                    }

                    .item-col~.item-col {
                        margin-left: 8px;
                    }
                }
            }

            .col4 {
                margin-left: 58px;
                a {
                    color: #ffffff;
                    text-decoration: none;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    font-weight: bold;
                }
            }
        }
        .footer-center {
            margin-top: 30px;
            height: 44px;
            ul {
                display: flex;
                align-items: center;
                img {
                    width: 44px;
                }
                .mover {
                    display: none;
                }
                li {
                    margin-right: auto;
                }
                li~li {
                    cursor: pointer;
                    width: 44px;
                    margin-right: 26px;
                    &:hover {
                        img {
                            display: none;
                        }
                        .mover {
                            display: block;
                        }
                    }
                }
                li:hover {
                    color: #fff;
                }
            }
        }
        .footer-down {
            margin-top: 48px;
            text-align: center;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            border-top: 1px solid rgba(255, 255, 255, 0.3);
            padding-top: 24px;
            .line-1 {
                display: flex;
                justify-content: center;
            }
            img {
                margin-right: 5px;
                position: relative;
                top: -4px;
                // vertical-align: middle;
                height: 20px;
            }
            span {
                margin-left: 5px;
                font-family: HelveticaNeue, Arial, sans-serif;
                font-weight: 400;
            }
            a {
                color: #fff;
            }
            a:hover {
               color: #fff; 
            }
        }
    }
}
</style>